import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { KanbanBoardHelperService, KanbanBoardStore } from '@store';

@Component({
  selector: 'app-dashboard-filter-input',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
  ],
  templateUrl: './dashboard-filter-input.component.html',
  styleUrls: ['./dashboard-filter-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardFilterInputComponent implements OnInit, OnDestroy {
  searchValue: FormControl<string> = new FormControl<string>('');

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    private kanbanBoardHelperService: KanbanBoardHelperService,
    private kanbanBoardStore: KanbanBoardStore
  ) {}

  ngOnInit(): void {
    this.searchValue.valueChanges
      .pipe(debounceTime(1000), takeUntil(this.ngUnsubscribe$))
      .subscribe((inputValue) => {
        this.kanbanBoardHelperService.filterInputSearchValue$.next(inputValue);
        this.kanbanBoardStore.applyDashboardFilter();
      });

    this.kanbanBoardHelperService.clearSearchInput$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(() => {
        this.searchValue.setValue('', { emitEvent: false });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.kanbanBoardHelperService.filterInputSearchValue$.next('');
  }
}
